// 正确导入方式
import provinces from 'china-division/dist/provinces.json'
import cities from 'china-division/dist/cities.json'
import areas from 'china-division/dist/areas.json'

// 构建级联数据格式
export const areaOptions = provinces.map(prov => ({
  value: prov.code,
  label: prov.name,
  children: cities
    .filter(city => city.provinceCode === prov.code)
    .map(city => ({
      value: city.code,
      label: city.name,
      children: areas
        .filter(area => area.cityCode === city.code)
        .map(area => ({
          value: area.code,
          label: area.name
        }))
    }))
}))
export function getAreaName (code) {
  if (!code) return ''
  // 处理包含省、市、区三级代码的格式，如"14/1404/140405"
  if (code.includes('/')) {
    const codes = code.split('/')
    const names = []
    // 遍历省份
    for (const province of areaOptions) {
      if (province.value === codes[0]) {
        names.push(province.label)

        // 遍历城市
        for (const city of province.children) {
          if (city.value === codes[1]) {
            names.push(city.label)
            // 遍历区县
            for (const area of city.children) {
              if (area.value === codes[2]) {
                names.push(area.label)
                break
              }
            }
            break
          }
        }
        break
      }
    }
    return names.join('')
  }
  // 处理单个代码的情况
  // 遍历省份
  for (const province of areaOptions) {
    if (province.value === code) {
      return province.label
    }
    // 遍历城市
    for (const city of province.children) {
      if (city.value === code) {
        return city.label
      }

      // 遍历区县
      for (const area of city.children) {
        if (area.value === code) {
          return area.label
        }
      }
    }
  }
  return ''
}
